<template>
  <div class="h-100" style="min-height: 1px">
    <b-overlay :blur="null" :show="loading" class="h-100" opacity="0">
      <transition mode="out-in" name="fadeDownShort">
        <div v-if="!loading" v-bar class="bar-out">
          <div>
            <div v-if="!data || data.length == 0" class="text-center my-3">
              <div class="mb-3">
                <b-icon font-scale="5" icon="question-diamond" />
              </div>
              <h2 class="mb-3">Žiadne dáta</h2>
            </div>
            <template v-else>
              <component
                :is="type + 'View'"
                v-if="type"
                ref="performanceView"
                :data="data"
                :note="note"
                :total="total"
                @loadMore="fetchData(true)"
                @onNoteChange="editNote"
              />
            </template>
          </div>
        </div>
      </transition>
    </b-overlay>
  </div>
</template>
<script>
import PowerView from '../performance/power/View'
import GasView from '../performance/gas/View'

export default {
  components: {
    PowerView,
    GasView,
  },
  data() {
    return {
      loading: false,
      type: this.$store.getters['energetic/getCurrentType'],
      data: [],
      page: 1,
      total: null,
      note: null,
    }
  },
  created() {
    this.fetchData()
  },
  mounted() {
    this.$root.$on('reloadPerformanceReportData', this.fetchData)
  },
  beforeDestroy() {
    this.$root.$off('reloadPerformanceReportData')
  },
  methods: {
    fetchData(silent = false) {
      this.loading = !silent
      this.axios
        .all([
          this.$api.get(
            `reports/${this.$route.params.energetics_id}/performance/get_report`,
            {
              params: {
                page: this.page,
              },
            },
          ),
          this.$api.get(
            `reports/${this.$route.params.energetics_id}/performance/get_note`,
          ),
        ])
        .then(
          this.axios.spread((report, note) => {
            if (report.data.data.length) {
              this.page += 1
              this.data = this.data.concat(report.data.data)
              this.total = report.data.meta.total
            }
            this.note = note.data.data
            if (!silent) {
              this.loading = false
            }
          }),
        )
    },
    editNote(val) {
      this.$api
        .post('reports/save_note', {
          energetics_id: this.$route.params.energetics_id,
          year: null,
          note: val,
        })
        .then((res) => {
          this.$refs.performanceView.noteSaved = res.data.success
        })
    },
    remove(year) {
      this.$swal({
        title: 'Ste si istý?',
        text: 'Naozaj chcete odstrániť tieto hodnoty?',
        type: 'info',
        position: 'top',
        showConfirmButton: true,
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$api
            .delete(
              `reports/${this.$route.params.energetics_id}/remove_performance/${year}`,
            )
            .then((res) => {
              this.$swal({
                type: 'success',
                position: 'top',
                showCloseButton: true,
                text: res.data.message,
                timer: 5000,
              })
              this.data = []
              this.page = 1
              this.fetchData()
            })
        }
      })
    },
  },
}
</script>
